import { StoreConstants } from "src/app/constants/StoreConstants";
import { CourseState } from "./course.state";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { Course } from "src/app/_models/Course";
import { HttpErrorResponse } from "@angular/common/http";
import { CourseGrouped } from "src/app/_models/CourseGrouped";
import { CourseCategory } from "src/app/_models/CourseCategory";

export const selectCourseState = createFeatureSelector<CourseState>(StoreConstants.STATE_CRS);

export const selectCourseList = createSelector(
  selectCourseState,
  (state: CourseState): Course[] => state.list
);

export const selectCourseListLoader = createSelector(
  selectCourseState,
  (state: CourseState): boolean => state.loading
);

export const selectCourseNamesByIds = createSelector(
  selectCourseState,
  (state: CourseState, ids: number[]): string[] => state.list.filter(x => {
    let exist = false;
    ids.forEach(id => {
        if(id === x.id)
          exist = true;
    });
   return exist;
}).map( x => x.name)
);

export const selectCourseNamesByLearnerCourse = createSelector(
  selectCourseState,
  (state: CourseState, courses: any[]): string[] => state.list.filter(x => {
    let exist = false;
    courses.forEach(course => {
        if(course.courseId === x.id)
          exist = true;
    });
   return exist;
}).map( x => x.name)
);

export const selectCourse = createSelector(
  selectCourseState,
  (state: CourseState): Course => state.course
);

export const selectCourseError = createSelector(
  selectCourseState,
  (state: CourseState): HttpErrorResponse => state.error
);

export const selectInUsedCoursesList = createSelector(
  selectCourseState,
  (state: CourseState): Course[] => state.inUsedCourses
)

export const selectCourseGroupedList = createSelector(
  selectCourseState,
  (state: CourseState): CourseGrouped[] => state.courseGrouped
)

export const selectCourseCategories = createSelector(
  selectCourseState,
  (state: CourseState): CourseCategory[] => state.courseCategories
);